import React from "react";
import { ReelMetadata } from "../../types";

interface LuxuryHeaderProps {
  data: ReelMetadata;
  opacity: number;
  scale: number;
  translateY: number;
}

export const LuxuryHeader: React.FC<LuxuryHeaderProps> = ({
  data,
  opacity,
  scale,
  translateY,
}) => {
  return (
    <div
      style={{
        width: "100%",
        background: "transparent",
        textAlign: "center",
        padding: "24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
        opacity,
        transform: `scale(${scale}) translateY(${translateY}px)`,
      }}
    >
      {/* Label row: thin gold lines flanking the brand label */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
          gap: "16px",
        }}
      >
        {/* Left divider */}
        <div
          style={{
            flex: 1,
            height: "1px",
            background: "rgba(201,168,76,0.6)",
          }}
        />

        {/* Label text */}
        <div
          style={{
            fontFamily: "'Cinzel', serif",
            fontSize: "11px",
            color: "#c9a84c",
            letterSpacing: "6px",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
          }}
        >
          LUXURY INTELLIGENCE
        </div>

        {/* Right divider */}
        <div
          style={{
            flex: 1,
            height: "1px",
            background: "rgba(201,168,76,0.6)",
          }}
        />
      </div>

      {/* Headline */}
      <h2
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "30px",
          fontStyle: "italic",
          fontWeight: 600,
          lineHeight: 1.35,
          color: "#fff8e7",
          margin: 0,
          textAlign: "center",
        }}
      >
        {data.headline}
      </h2>

      {/* Bottom decorative gold line */}
      <div
        style={{
          width: "60px",
          height: "1px",
          background: "#c9a84c",
          opacity: 0.7,
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
